import React from "react";
import "./TableControls.css";

const TableControls = ({
  activeView,
  handleViewChange,
  scrollToTable,
  dayWiseRef,
  weeklyRef,
  monthlyRef,
}) => {
  return (
    <div className="table-controls-wrapper">
      
      {/* Toggle Buttons */}
      <div className="tc-toggle-buttons">
        <button
          onClick={() => handleViewChange("Open")}
          className={activeView === "Open" ? "tc-active" : ""}
        >
          Open View
        </button>

        <button
          onClick={() => handleViewChange("DS")}
          className={activeView === "DS" ? "tc-active" : ""}
        >
          DS View
        </button>

        <button
          onClick={() => handleViewChange("BR")}
          className={activeView === "BR" ? "tc-active" : ""}
        >
          BR View
        </button>
      </div>

      {/* Scroll Buttons */}
      <div className="tc-scroll-buttons">
        <button onClick={() => scrollToTable(dayWiseRef)}>
          ↓ Day-wise Data
        </button>

        <button onClick={() => scrollToTable(weeklyRef)}>
          ↓ Weekly Data
        </button>

        <button onClick={() => scrollToTable(monthlyRef)}>
          ↓ Monthly Data
        </button>
      </div>

    </div>
  );
};

export default TableControls;
